import { Tag } from "../models/tag.model";

export class MemberSearch {
  pictureUrl?: string;
  id: string;
  memberId: number;
  firstName: string;
  lastName: string;
  fullName?: string;
  userId?: string;
  dateOfBirth: Date;
  phoneNumber: string;
  primary: string;
  email: string;
  address: string;
  longitude: number;
  latitude: number; 
  frequency: number;
  enablePoints: boolean; 
  expandFunctions?: boolean;
  expanded?: boolean;
  confirmView?: boolean;
  editView?: boolean;
  toolsHelp?: boolean;  
  hasNotes: boolean;
  tags: Tag[];
}
